import skuIsOverQuantityLimit from './skuIsOverQuantityLimit';
import type { CartSkuOption } from '../types';
import t from '@rcm/i18n-client';

/**
 * Returns all relevant messages pertaining to an attempt to
 */
export default function calcTranslatedSkuWarningMessages(
    sku: CartSkuOption,
    quantity: number,
    amountIsValid?: boolean,
): string[] {
    const messages = [];
    if (skuIsOverQuantityLimit(sku, quantity)) {
        messages.push(
            t(
                'The maximum quantity allowed per order for ' +
                'individual items of {productName} is ' +
                '{maxQty}. Please order cases instead.',
                {
                    maxQty: sku.maxQuantityAllowedPerOrder.toString(),
                    productName: sku.name,
                }
            )
        );
    }
    if (sku.isBackOrdered) {
        messages.push(t('This item is backordered.'));
    }

    if (!amountIsValid && amountIsValid !== undefined) {
        messages.push(t('Amount must be a number.'));
    }

    if (!sku.isAvailableForPurchase) {
        messages.push(t('This item is temporarily out of stock due to high demand and will be back in stock soon.'));
    }
    return messages;
}
